import React from 'react';
import { useIntl } from 'react-intl';
import Divider from '@fuww/library/src/Login/Divider';
import withApollo from '../lib/apollo';
import { CaptchaProvider } from '../components/Captcha';
import SignupComponent from '../components/LoginSignup/Signup';
import SignupForm from '../components/LoginSignup/SignupForm';
import { Link } from '../routes.mjs';
import SignupWithProviderForm
  from '../components/LoginSignup/SignupWithProviderForm';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import messages from '../lib/messages.json';
import RedirectWhenLoggedIn
  from '../components/LoginSignup/RedirectWhenLoggedIn';
import { Registrar } from '../lib/graphql/api/graphql';

const registeredVia = Registrar.MARKETPLACE;

export const SignupBuyer = () => {
  const intl = useIntl();

  return (
    <CaptchaProvider>
      <SignupComponent
        infoPanel={(
          <div>
            <span>
              Sign up for free and search thousands of products from
              fashion brands all over the world and discover their
              available, current and future collections.
            </span>
            <ul>
              <li>Free Unlimited access to international buying data</li>
              <li>Discover new brands, get inspired by new collections</li>
              <li>Access to all collections in all segments</li>
              <li>Specific filtering to meet your needs and search criteria</li>
              <li>Hidden buyer profile</li>
              <li>
                Readily available trend news, video shows, webinars
                and podcasts exclusively for Fashion Buyers
              </li>
              <li>
                Save time and money looking for specific items, going
                on buying trips and visiting fashions fairs/shows
              </li>
            </ul>
          </div>
        )}
        redirectLink={(
          <>
            {intl.formatMessage(
              messages['register.notABuyer'],
            )}
            <Link route="register" passHref>
              {intl.formatMessage(
                messages['register.basicRegistration'],
              )}
            </Link>
          </>
          )}
      >
        <SignupForm isBuyer registeredVia={registeredVia} />
        <Divider dividerText="OR CONTINUE WITH" />
        <SignupWithProviderForm
          provider="google"
          buyer
        />
        <SignupWithProviderForm
          provider="linkedin"
          buyer
        />
        <RedirectWhenLoggedIn />
      </SignupComponent>
    </CaptchaProvider>
  );
};

SignupBuyer.getInitialProps = redirectRouteToDomain(
  'register-buyer',
);

export default withApollo(SignupBuyer);
